import { __rest } from 'tslib';
import React__default, { useMemo } from 'react';
import { Caption } from '../Typography/index.es.js';
import { CommonStyles } from '../BaseProps/index.es.js';
import styled from '@emotion/styled';

const BadgeWrapper = styled.div `
  position: relative;
  ${CommonStyles}
`;
const StyledBadge = styled.div(({ theme, top, right, color }) => `
  min-width: ${theme.spacing.s16};
  height: ${theme.spacing.s16};
  padding: ${theme.spacing.s0} ${theme.spacing.s4};
  background: ${color ? color : theme.colors.error500};
  border-radius: ${theme.borderRadius.m};
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: ${top ? (typeof top === 'number' ? `${top}px` : top) : 0};
  right: ${right ? (typeof right === 'number' ? `${right}px` : right) : 0};
  transform: translate(50%,-50%);
  transform-origin: 100% 0;
`);
const StyledCaption = styled(Caption) `
  text-align: center;
`;
const Badge = (_a) => {
    var { count, offset, overflowCount = 99, showZero = false, color, children } = _a, rest = __rest(_a, ["count", "offset", "overflowCount", "showZero", "color", "children"]);
    const displayCount = useMemo(() => {
        return count < 0
            ? 0
            : overflowCount && count > overflowCount
                ? `${overflowCount}+`
                : count;
    }, [count, overflowCount]);
    const [top, right] = offset ? offset : [];
    return (React__default.createElement(BadgeWrapper, Object.assign({}, rest),
        children,
        (count > 0 || (count === 0 && showZero)) && (React__default.createElement(StyledBadge, { top: top, right: right, color: color },
            React__default.createElement(StyledCaption, { level: 3, color: "white" }, displayCount)))));
};

export { Badge };
